export default __webpack_public_path__ + "static/logo-1bf901829c26b98621ffaa22b2825f78.svg";